








import Vue from 'vue'
export default Vue.extend({
    mounted() {
        this.$nextTick(() => {
            //  Grab our parent
            const elem = this.$refs['choose-number']

            //  Create a script tag
            const typeform = document.createElement('script')

            //  Set the source
            typeform.setAttribute('src', 'https://embed.typeform.com/next/embed.js')

            //  Append our script
            elem.appendChild(typeform)
        })
    }
})
